import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
      color: theme.palette.common.white,
    },
    linkRoot:{
      '& > * + * ': {
        marginLeft: theme.spacing(5),
      },
    },
    link: {
      color: theme.palette.common.white,
    },
    nomalMenu:{
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      },
      [theme.breakpoints.up('md')]: {
        display: 'true',
      },
    },
    dropDownMenu: {
      [theme.breakpoints.down('sm')]: {
        display: 'true',
      },
      [theme.breakpoints.up('md')]: {
        display: 'none'
      },
    }
}));

const Header = (props) => {
  const {visibleHome} = props
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(null);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (item: string) => {
    window.location.href = '../' + item;
  };

  return (
    <>
      <AppBar position="sticky" id="back-to-top-anchor">
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            ANFANG
          </Typography>
          <div className={classes.nomalMenu}>
            <Typography variant="h6" className={classes.linkRoot}>
              {visibleHome &&
                <Link onClick={e => handleClose('')} underline='none' className={classes.link}>home</Link>
              }
              <Link onClick={e => handleClose('profile')} underline='none' className={classes.link}>profile</Link>
              <Link onClick={e => handleClose('illustration')} underline='none' className={classes.link}>illustration</Link>
              <Link onClick={e => handleClose('request')} underline='none' className={classes.link}>request</Link>
            </Typography>
          </div>
          <div className={classes.dropDownMenu}>
            <IconButton 
              onClick={handleClick}
              edge="start" 
              className={classes.menuButton} 
              color="inherit" 
              aria-label="menu">
              <MenuIcon />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                { visibleHome &&
                  <MenuItem onClick={e => handleClose('')}>home</MenuItem>
                }
                <MenuItem onClick={e => handleClose('profile')}>profile</MenuItem>
                <MenuItem onClick={e => handleClose('illustration')}>illustration</MenuItem>
                <MenuItem onClick={e => handleClose('request')}>request</MenuItem>
              </Menu>
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
}

export default Header;